var template = require('../../templates/employee/LayoutContent.ejs');

var PersonalInfoView = require('../employee/PersonalInfo');
var EmploymentDetailsView = require('../employee/EmploymentDetails');
var StatutoryRequirementsView = require('../employee/StatutoryRequirements');
var PreviousPayslipsView = require('../employee/PreviousPayslips');
var ActionLogView  = require('commons/views/ActionLog');

module.exports = Backbone.View.extend({

    contentView: null,

    events: {
        'click .js-employment-details-tab': 'trackEmploymentDetails'
    },

    // TODO: favor convention over configuration
    tabConfigs: {
        personalInfo: {
            tabClass: '.js-personal-info-tab',
            tabContentClass: '.js-personal-info-tab-content'
        },
        employmentDetails: {
            tabClass: '.js-employment-details-tab',
            tabContentClass: '.js-employment-details-tab-content'
        },
        statutoryRequirements: {
            tabClass: '.js-statutory-requirements-tab',
            tabContentClass: '.js-statutory-requirements-tab-content'
        },
        previousPayslips: {
            tabClass: '.js-previous-payslips-tab',
            tabContentClass: '.js-previous-payslips-tab-content'
        },
        actionLog: {
            tabClass: '.js-action-log-tab',
            tabContentClass: '.js-action-log-tab-content'
        }
    },

    render: function() {
        var self = this;

        self.$el.html(template({
            employeeId: self.model && !self.model.isNew() ? self.model.id : '',
            isNew: self.isNew
        }));

        if (self.model && self.model.isNew()) {
            self.$('.js-nav-tabs li').addClass('disabled');
        }

        var tabConfig = self.tabConfigs[self.tab];
        self.$(tabConfig.tabClass).addClass('active').removeClass('disabled');
    },

    renderContent: function(options) {
        var self = this;
        self.model = options.model;
        self.isNew = options.isNew;

        self.render();

        var tabConfig = self.tabConfigs[self.tab];
        self.$(tabConfig.tabContentClass).addClass('active');

        if (this.contentView) {
            this.contentView.remove();
        }

        if (self.tab === 'personalInfo') {
            this.contentView = new PersonalInfoView(options);
            this.$('.js-personal-info').html('').append(this.contentView.$el);
        } else if (self.tab === 'employmentDetails' && options.leaveTypes) {
            this.contentView = new EmploymentDetailsView(options);
            this.$('.js-employment-details').html('').append(
                this.contentView.$el
            );
        } else if (self.tab === 'statutoryRequirements') {
            this.contentView = new StatutoryRequirementsView(options);
            this.$('.js-statutory-requirements').html('').append(
                this.contentView.$el
            );
        } else if (self.tab === 'previousPayslips' && options.yearlyTotals) {
            this.contentView = new PreviousPayslipsView(options);
            this.$('.js-previous-payslips').html('').append(
                this.contentView.$el
            );
        } else if (self.tab === 'actionLog' && options.collection) {
            this.contentView = new ActionLogView(options).render();
            this.$('.js-action-log').html('').append(
                this.contentView.$el
            );
        }
    },

    trackEmploymentDetails: function() {
    },
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/LayoutContent.js